module.exports = __webpack_public_path__ + "ionicons.svg";


//////////////////
// WEBPACK FOOTER
// ./~/ionicons/fonts/ionicons.svg?v=2.0.1
// module id = 1148
// module chunks = 14